import { render } from "./AdmCreateUser.vue?vue&type=template&id=62867b1e&scoped=true&ts=true"
import script from "./AdmCreateUser.vue?vue&type=script&lang=ts"
export * from "./AdmCreateUser.vue?vue&type=script&lang=ts"

import "./AdmCreateUser.vue?vue&type=style&index=0&id=62867b1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62867b1e"]])

export default __exports__